import {
  CustomCheckbox,
  Select,
  SuperannuationDetailsSchema,
  Superannuation_InitialState,
  TextArea,
  TextInput,
  useOptions
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import React, { FC } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: Superannuation_InitialState;
  onSubmit: (values: Superannuation_InitialState) => void;
}

const Step01: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { ownerV1Options, ownerV2Options } = useOptions({ initialDetails });
  const { handleSubmit, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(SuperannuationDetailsSchema)
  });

  const isSelfManaged =
    useWatch({
      control,
      name: "if_self_managed"
    }) === "yes";

  const ownerOptions = isSelfManaged ? ownerV2Options : ownerV1Options;

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <TextInput title="Name of the super fund?" control={control} name="name" id="name" />

      <CustomCheckbox
        control={control}
        name="if_self_managed"
        title="Click if this self managed super fund"
        valueType="string"
      />
      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput
        title="Current super balance?"
        subTitle="You can check this in myGov. If you don’t know estimate."
        control={control}
        name="value"
        id="value"
        placeholder="eg $85,000"
        isAmount
      />
      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title="In whose name is this super fund in?"
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerOptions}
      />

      {!isSelfManaged ? (
        <>
          <hr className="mt-7 mb-10 bg-gray-500 w-full" />
          <TextInput
            title="What’s the member number?"
            control={control}
            name="member_number"
            id="member_number"
            placeholder=""
          />
        </>
      ) : null}

      {isSelfManaged ? <hr className="mt-7 mb-10 bg-gray-500 w-full" /> : null}

      {isSelfManaged ? (
        <TextInput
          title="Trustee of the Self Managed Super Fund"
          control={control}
          name="trustee_smsf"
          id="trustee_smsf"
          placeholder=""
        />
      ) : null}

      {isSelfManaged ? (
        <TextArea
          title="Do want to tell us anything else about this fund (optional)"
          control={control}
          name="details"
          id="details"
          placeholder="Description"
          className="mt-5"
        />
      ) : null}
    </form>
  );
};
export default Step01;
